<template>
  <div>
    <h2 class="blind">사용내역</h2>
    <span class="gray-text">이마티콘 사용내역을 확인하실 수 있습니다.</span>
    <div class="category-box">
      <select v-if="cardList.length === 1" v-model="prepaidCardNo" @change="getPrepaidCardRedeemDetail">
        <option v-for="(item, index) in cardList" :key="index" :value="item.prepaidCardNo">{{item.prepaidCardNickName}} </option>
      </select>
      <button v-if="cardList.length > 1" type="button" class="menu-button" v-on:click="handlerClickSelect"><span>{{prepaidCardNickName}}</span></button>
      <order-select v-if="isSelect" :cardList="cardList" @select-card="selectPrepaidCard"></order-select>
    </div>
    <ul class="mydetail-button-list">
      <li><button :class="{'focus' : selectPeriod === '1month'}" @click.prevent="selectPeriod = '1month'">1개월</button><h2 class="blind" v-if="selectPeriod === '1month'">선택됨</h2></li>
      <li><button :class="{'focus' : selectPeriod === '3month'}" @click.prevent="selectPeriod = '3month'">3개월</button><h2 class="blind" v-if="selectPeriod === '3month'">선택됨</h2></li>
      <li><button :class="{'focus' : selectPeriod === '6month'}" @click.prevent="selectPeriod = '6month'">6개월</button><h2 class="blind" v-if="selectPeriod === '6month'">선택됨</h2></li>
      <li><button :class="{'focus' : selectPeriod === 'select'}" @click.prevent="selectPeriod = 'select'">기간조회</button><h2 class="blind" v-if="selectPeriod === 'select'">선택됨</h2></li>
    </ul>
    <h2 class="blind">{{selectPeriodText}}</h2>
    <div class="usage-date-box" v-if="selectPeriod==='select'">
      <input type="date" name="firstDate" v-model="startDate" data-placeholder="시작일" @change="validPeriod" required/>
      <input type="date" name="lastDate" v-model="lastDate" data-placeholder="종료일" @change="validPeriod" required/>
      <button type="button" @click.prevent="searchPeriod">검색</button>
    </div>
    <div class="usage-gray-box">
      <div>
        <span>총 사용 금액</span>
        <em>{{redeemSum | comma}}</em>
      </div>
    </div>
    <use-history :list-data="useListData"></use-history>
    <alert-popup v-if="alertPopupShow" :message="alertMessage" @confirmPopupClickConfirm="alertPopupShow = false"></alert-popup>
    <pagination
        :totalRows="useListTotalRow"
        :pageModel="pageModel"
        v-on:movePage="movePage"
    />
  </div>
</template>

<script>
import UseHistory from '@/components/common/UseHistory.vue';
import dayjs from 'dayjs';
import apiList from "@/api/apiList";
import AlertPopup from "@/views/myemarticon/alertPopup";
import Pagination from "@/components/common/Pagination";
import OrderSelect from "@/components/common/OrderSelect";

export default {
  name: "myDetailUse",
  components: { UseHistory, AlertPopup, Pagination, OrderSelect },
  data() {
    return {
      cardList: [],
      prepaidCardNo: '',
      selectPeriodText: '1개월', //웹접근성
      selectPeriod: '1month',
      startDate: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      lastDate: dayjs().format('YYYY-MM-DD'),
      redeemSum: 0,
      // 사용내역 데이터
      useListData: [
      ],
      pageModel: {
        size: 5,
        pageNo: 1
      },
      useListTotalRow: 0,
      alertMessage: "",
      alertPopupShow: false,
      isSelect: false,
      prepaidCardNickName: '전체'
    }
  },
  filters: {
    comma(num) {
      return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  watch: {
    selectPeriod(value) {
      switch (value) {
        case '1month' :
          this.startDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '1개월';
          break;
        case '3month' :
          this.startDate = dayjs().subtract(3, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '3개월';
          break;
        case '6month' :
          this.startDate = dayjs().subtract(6, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '6개월';
          break;
        case 'select' :
          this.startDate = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '기간조회';
          break;
        default:
          this.startDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          this.selectPeriodText = '1개월';
      }
      this.pageModel.pageNo = 1;
      this.useListData = [];
      this.getPrepaidCardRedeemDetail();
    }
  },
  mounted() {
    this.getPrepaidCardList();
  },
  methods: {
    async getPrepaidCardList() {
      try{
        const param = {
          status: ''
        }
        const response = await apiList.getPrePaidCardBoxList(param); //카드 보관함 조회
        if(response.data.data) {
          // this.cardList = response.data.data.filter(obj => obj.status.includes('ACTIVATION') || obj.status.includes('LOCKED'))
          this.cardList = response.data.data;
        }
        this.cardList.unshift({prepaidCardNickName:'전체', prepaidCardNo:''});
        this.getPrepaidCardRedeemDetail();

      } catch (error) {
        console.error(error);
      }
    },
    async getPrepaidCardRedeemDetail() {
      try{
        const param = {
          startDate: this.startDate,
          endDate: this.lastDate,
          size: this.pageModel.size,
          pageNo: this.pageModel.pageNo,
          prepaidCardNo: this.prepaidCardNo
        };

        (!param.prepaidCardNo) && delete param.prepaidCardNo;

        const response = await apiList.getPrepaidRedeemDetail(param);
        this.redeemSum = response.data.data.redeemSum; //총 사용 금액
        this.useListTotalRow =  response.data.data.redeemDetails.totalRows;
        this.prepaidCardRedeemDetailList(response.data.data.redeemDetails.list); //사용내역

      } catch (error) {
        console.error(error);
      }
    },
    prepaidCardRedeemDetailList(list) {
      this.useListData = [];
      for(let data of list) {

        let text = "";

        if(data.purchaseCode === "REFUND") {
          text = "환불";
        } else if(data.purchaseCode === "EXPIRATION") {
          text = "만료";
        } else if(data.voided){
          text = data.merchantName+"[사용취소]";
        } else if(!data.voided) {
          // eslint-disable-next-line no-unused-vars
          text = data.merchantName;
        }
        //선불카드 상태 체크 로직
        let cardInfo = this.cardList.filter(item => {
              if(item.prepaidCardNo === data.prepaidCardNo) {
                return item;
              }
          }
        )

        const param = {
          text: text,
          price: data.voided? "+"+data.redemptionCash:"-"+data.redemptionCash,
          firstDate: dayjs(data.transactionDateTime).format('YYYY/MM/DD'),
          lastDate: dayjs(data.transactionDateTime).format('HH:mm'),
          imageName: data.thumbnailImageUrl,
          imageAlt: data.thumbnailImageDesc,
          status: cardInfo[0]? cardInfo[0].status : ''
        }

        this.useListData.push(param);
      }
    },
    searchPeriod() {
      if(dayjs(this.lastDate).diff(dayjs(this.startDate), 'day') > 365) {
        this.alertPopupShow = true;
        this.alertMessage = '조회기간은 최대 12개월 입니다.';
        return;
      }

      if(!this.validPeriod()) {
        return;
      }
      this.useListData = [];
      this.pageModel.pageNo = 1;
      this.getPrepaidCardRedeemDetail();
    },
    validPeriod() {
      if(this.startDate > this.lastDate) {
        this.alertPopupShow = true;
        this.alertMessage = '종료일이 시작일보다 이전일 수는 없습니다.';
        return false;
      }
      return true;
    },
    movePage(pageNo) {
      this.pageModel.pageNo = pageNo;
      this.getPrepaidCardRedeemDetail();
    },
    handlerClickSelect() {
      if(this.cardList.length > 1) {
        this.isSelect = !this.isSelect;
      }
    },
    selectPrepaidCard(item) {
      this.isSelect = false;
      this.prepaidCardNo = item.prepaidCardNo;
      this.prepaidCardNickName = item.prepaidCardNickName;
      this.useListData = [];
      this.pageModel.pageNo = 1;
      this.getPrepaidCardRedeemDetail();
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '@/assets/styles/pages/myemarticon/myDetail.scss';
</style>
